import { useCallback, useEffect, useState } from "react"

import { openModal } from "components/modal"
import Button from "components/ui/button"
import { IS_INT, IS_UK, isTestMode } from "helpers/application"
import { getStoredConsent } from "helpers/consent"

const ConsentBanner = () => {
  const storedConsent = getStoredConsent()
  const [showBanner, setShowBanner] = useState(!storedConsent)

  const handleAcceptAll = useCallback(() => {
    const consent = { ad_storage: "granted", analytics_storage: "granted" }

    if (!isTestMode) {
      dataLayer.push({
        ...consent,
        event: "consent-update",
      })
    }

    setShowBanner(false)

    if (typeof window !== "undefined") {
      window.dispatchEvent(new Event("consent_update"))
    }
  }, [])

  useEffect(() => {
    const handleConsentUpdate = () => setShowBanner(false)

    window.addEventListener("consent_update", handleConsentUpdate)

    return () =>
      window.removeEventListener("consent_update", handleConsentUpdate)
  }, [])

  if (!(IS_UK() || IS_INT()) || !showBanner || isTestMode) {
    return null
  }

  return (
    <div
      className="tablet:p-32 desktop:flex-row fixed bottom-0 z-40 flex w-full flex-col items-center justify-between gap-20 bg-white px-16 py-24"
      data-cy="consent-banner"
      style={{
        boxShadow:
          "0 -4px 6px -1px rgb(0 0 0 / 0.1), 0 -2px 4px -2px rgb(0 0 0 / 0.1)",
      }}
    >
      <p className="body desktop:max-w-768 font-semibold">
        By clicking &ldquo;Accept All&rdquo;, you agree to the storing of
        cookies on your device to enhance site navigation, analyze site usage,
        and assist in our marketing efforts.
      </p>
      <div className="desktop:flex-row tablet:gap-16 desktop:w-auto flex w-full flex-col gap-12">
        <Button
          className="desktop:w-auto desktop:h-48 w-full"
          data-cy="consent-banner-manage-settings"
          onClick={() => openModal("#privacy-preferences")}
          size="sm"
          variant="secondary"
        >
          Manage Settings
        </Button>
        <Button
          className="desktop:w-auto desktop:h-48 w-full"
          data-cy="consent-banner-accept-all"
          onClick={handleAcceptAll}
          size="sm"
          variant="primary"
        >
          Accept All
        </Button>
      </div>
    </div>
  )
}

export default ConsentBanner
